import React from 'react'
import '../../css/visualComponent/Product.css'

export const Product = ({cssClass, imageName, title, description}) => {

    return (
        <>
            <div className={`${cssClass} ${imageName}`}>
                <div className={`product-image product-image-${imageName}`}></div>
                <div className='product-image-text'>
                    <h3>{title}</h3>
                    <p>{description}</p>
                </div>
            </div>
        </>
    )
}
